import { render, staticRenderFns } from "./quesInstru3.vue?vue&type=template&id=66827396"
import script from "./quesInstru3.vue?vue&type=script&lang=js"
export * from "./quesInstru3.vue?vue&type=script&lang=js"
import style0 from "./quesInstru3.vue?vue&type=style&index=0&id=66827396&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports